<template>
	<div class="settings-wrapper">
		<BackToSettings />
		<h2 class="title" v-t="title" />
		<div class="settings-detail">
			<div class="description" v-t="description" />

			<FormItem :label="$t('admin_people_email_label')">
				<Input
					:placeholder="$t('settings_profile_title_placeholder')"
					v-model="email"
				>
				</Input>
			</FormItem>

			<FormItem :label="$t('settings_feedback_comments')">
				<textarea
					ref="comments"
					rows="10"
					data-min-rows="10"
					class="feedback-textarea"
					v-model="comments"
				>
				</textarea>
			</FormItem>

			<Button
				class="submit-button"
				large
				pronto
				:disabled="disabled"
				@click="submitFeedback"
				v-t="'common_button_send'"
			/>
		</div>
	</div>
</template>

<script>
import store, { getMyUser, getOrganization } from '@/store'
import { Button, FormItem, Input } from '@/components/common'
import BackToSettings from './BackToSettings'

export default {
	name: 'Feedback',
	components: { BackToSettings, Button, FormItem, Input },
	props: {
		title: String,
		description: String,
	},
	data() {
		return {
			email: store.auth.user?.emails?.[0]?.email ?? '',
			comments: '',
		}
	},
	mounted() {
		this.$nextTick(() => {
			this.$refs.comments?.focus()
		})
	},
	computed: {
		disabled() {
			return !this.email || !this.comments
		},
	},
	methods: {
		submitFeedback() {
			const user = getMyUser()
			const org = getOrganization()

			const error = new Error('User Bug Report')

			this.$bugsnag.notify(error, (event) => {
				e.context = 'Feedback.vue'
				event.setUser(user.id, this.email, user.fullname)
				event.addMetadata('comment', this.comments)
				if (org)
					event.addMetadata('organization', {
						id: org.id,
						name: org.name,
					})
			})

			this.$alert.success(this.$t('settings_feedback_success'))
			this.$router.push({
				name: 'mainsettings',
				params: { id: org.id },
			})
		},
	},
}
</script>

<style lang="scss" scoped>
.settings-wrapper {
	overflow-y: auto;
	padding-bottom: 60px;
}

h2.title {
	width: 100%;
	font-size: 30px;
	margin-bottom: 16px;
	text-align: center;
}
.description {
	margin-bottom: 32px;
}

.feedback-textarea {
	width: 100%;
	padding: 8px 16px;
	font-size: 16px;
	color: var(--neutral-800);
	background-color: inherit;
	font-family: Avenir-Roman;
	line-height: 1.15;
	margin: 0;
	border-radius: 6px;
	border: 1px solid var(--neutral-200);
	outline: none;
	background: #fafafa;
	&:focus {
		border-color: var(--blue-300);
	}
}

.submit-button {
	margin-top: 25px;
}
</style>

<style lang="scss">
@import 'src/sass/variables';

@include overrideScheme('dark') {
	.settings-detail {
		.feedback-textarea {
			background-color: var(--neutral-100);
			&:focus {
				border-color: var(--teal-300);
			}
		}
	}
}
</style>
